import _ from 'lodash';

const state = {
  read: {},
  favorites: [],
  layout: 'grid',
  categories: [],
  collection: [],
  page: 2,
  termValue: 0,
};

const getters = {
  getSearchprofilesRead: (state) => state.all,
  getSearchprofilesFavorites: (state) => state.favorites,
  getSearchprofilesLayout: (state) => state.layout,
  getSearchprofilesCategories: (state) => state.categories,
  getSearchprofilesCollection: (state) => state.collection,
  getSearchprofilesPage: (state) => state.page,
  getSearchprofilesIsGrid: (state) => {
    return state.layout === 'grid';
  },
  getSearchprofilesIsMap: (state) => {
    return state.layout === 'map';
  },
  getSearchprofilesTerm: (state) => state.termValue,
};

const actions = {
  /* getSearchprofiles ({ commit }) {
    shop.getProducts(products => {
      commit(types.RECEIVE_PRODUCTS, { products })
    })
  } */
};

const mutations = {
  SET_SEARCHPROFILES_READ(state, data) {
    state.read = data;
  },
  SET_SEARCHPROFILES_FAVORITES(state, data) {
    state.favorites = data;
  },
  SET_SEARCHPROFILES_LAYOUT(state, type) {
    state.layout = type;
  },
  SET_SEARCHPROFILES_CATEGORIES(state, data) {
    state.categories = data;
  },
  SET_SEARCHPROFILES_COLLECTION(state, data) {
    state.collection = data;
  },
  PUSH_TO_SEARCHPROFILES_COLLECTION(state, data) {
    _.each(data, (item) => {
      state.collection.push(item);
    });
  },
  INCREASE_SEARCHPROFILES_PAGE(state) {
    state.page = state.page + 1;
  },
  SET_SEARCHPROFILES_TERM_VALUE(state, payload) {
    state.termValue = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
